import styles from "./SearchPartnerProfilePagination.module.css";
import { OutlinedButton } from "../common/Button/Button";
import React from "react";
import useTranslation from "next-translate/useTranslation";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa6";

interface Props {
  page: number;
  totalPages: number;
  onPrevClick: () => void;
  onNextClick: () => void;
}

export default function SearchPagination({
  onPrevClick,
  onNextClick,
  page = 1,
  totalPages = 1,
}: Props) {
  const { t } = useTranslation("common");

  return (
    <div className={styles.container}>
      <div className={styles.controlContainer}>
        <OutlinedButton
          onClick={onPrevClick}
          content={<FaChevronLeft />}
          disabled={page === 1}
        />
        <div className={styles.page}>{page}</div>
        <OutlinedButton
          onClick={onNextClick}
          content={<FaChevronRight />}
          disabled={page === totalPages}
        />
      </div>
    </div>
  );
}
